import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _noop from 'lodash/noop';
import _get from 'lodash/get';

// Factory
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import getRenderConfig from './factory/filtersList.component';
import getFilterValueOnChange from './factory/filter.filterValue';

// Readers
import filterTypeReader from '../../../readers/FilterType';

// Styles
import s from './filter.module.scss';
var Filter = /*#__PURE__*/function (_PureComponent) {
  _inherits(Filter, _PureComponent);
  var _super = _createSuper(Filter);
  function Filter() {
    var _this;
    _classCallCheck(this, Filter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var _this$props = _this.props,
        filterType = _this$props.filterType,
        onChange = _this$props.onChange;
      for (var _len2 = arguments.length, valueParams = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        valueParams[_key2] = arguments[_key2];
      }
      var filterValue = getFilterValueOnChange.apply(void 0, [filterType].concat(valueParams));
      onChange(filterValue);
    });
    return _this;
  }
  _createClass(Filter, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        filterType = _this$props2.filterType,
        values = _this$props2.values,
        additional = _this$props2.additional,
        isFilterLabelStacked = _this$props2.isFilterLabelStacked,
        containerClassname = _this$props2.containerClassname;
      var renderConfig = getRenderConfig(filterType, values, additional);
      var Component = renderConfig.component || null;
      var filterName = filterTypeReader.name(filterType);
      var id = _get(filterType, 'id');
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(s.container, _defineProperty({}, s.isStacked, isFilterLabelStacked), containerClassname)
      }, filterName && /*#__PURE__*/React.createElement("div", {
        className: classnames(s.filterName, _defineProperty({}, s.isStacked, isFilterLabelStacked))
      }, filterName, ": "), /*#__PURE__*/React.createElement(Component, _extends({}, renderConfig.baseProps, {
        onChange: this.handleChange,
        onApply: this.handleChange,
        id: id
      })));
    }
  }]);
  return Filter;
}(PureComponent);
Filter.propTypes = {
  filterType: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  values: PropTypes.any,
  // eslint-disable-line react/require-default-props
  additional: PropTypes.any,
  // eslint-disable-line react/require-default-props
  isFilterLabelStacked: PropTypes.bool,
  containerClassname: PropTypes.string
};
Filter.defaultProps = {
  onChange: _noop,
  isFilterLabelStacked: false,
  containerClassname: EMPTY_STRING
};
export default Filter;